export default __webpack_public_path__ + "static/media/shampoo.9c195123.svg";